import { render, staticRenderFns } from "./acknowledgementEdit.vue?vue&type=template&id=071f94fc"
import script from "./acknowledgementEdit.vue?vue&type=script&lang=js"
export * from "./acknowledgementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports